const FileTransferSvg = ({
  height = 20,
  width = 20,
  viewBox = '0 0 512 512',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox={viewBox}
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
M513.000000,209.000000
	C513.000000,310.289764 513.000000,411.579559 513.000000,512.934692
	C342.450287,512.934692 171.900528,512.934692 1.000000,512.934692
	C1.000000,448.645081 1.000000,384.289520 1.345215,319.548706
	C3.019944,321.169769 4.055612,323.469269 5.721942,325.139557
	C48.326084,367.845306 90.923378,410.558594 133.740143,453.050659
	C139.567413,458.833771 147.246857,460.269562 154.590363,457.051117
	C162.231812,453.702118 165.913269,447.537537 165.967209,439.337982
	C166.076843,422.674500 165.994308,406.009735 166.010178,389.345520
	C166.011536,387.922852 166.156418,386.500275 166.238892,385.000000
	C209.506897,385.000000 252.327164,385.001648 295.147430,384.993164
	C296.642456,384.992859 298.378754,385.371765 299.593872,384.760895
	C308.414429,380.326508 313.236420,374.948669 311.960327,362.705780
	C311.165100,355.076294 302.729706,348.027374 294.446838,348.020416
	C245.120789,347.979126 195.794525,347.942200 146.468689,348.056091
	C138.103210,348.075378 128.524887,355.120026 128.927582,365.796021
	C129.276047,375.033813 129.000000,384.295197 129.000000,393.562012
	C101.384079,365.929443 73.996674,338.525513 47.376148,311.888947
	C74.363640,284.902679 101.809715,257.457855 129.000000,230.268814
	C129.000000,238.383667 129.563278,247.232178 128.860474,255.978958
	C127.937332,267.468109 136.752945,276.083313 149.247650,276.058777
	C213.737930,275.932098 278.228607,276.000000 342.719147,276.000000
	C344.462433,276.000000 346.205750,276.000000 348.000000,276.000000
	C348.000000,294.229370 348.223053,311.730225 347.912140,329.221588
	C347.739502,338.933807 353.138977,345.064331 359.501862,347.662109
	C367.436768,350.901703 374.703583,348.839325 380.848206,342.685913
	C421.707184,301.768433 462.626373,260.911102 503.463562,219.971939
	C506.877655,216.549301 509.832031,212.668121 513.000000,209.000000
z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
M1.000001,304.000000
	C1.000000,203.043411 1.000000,102.086830 1.000000,1.065125
	C171.549866,1.065125 342.099762,1.065125 513.000000,1.065125
	C513.000000,65.688255 513.000000,130.377151 512.650146,195.437805
	C510.940643,193.448868 510.015137,190.655685 508.157562,188.790909
	C465.585083,146.053253 422.912781,103.415031 380.252808,60.764545
	C376.398621,56.911221 371.309875,54.767517 366.283325,55.218140
	C354.518890,56.272812 347.641418,64.614304 347.905975,76.105507
	C348.277893,92.261337 348.005920,108.432137 347.989716,124.596519
	C347.988281,126.024178 347.842102,127.451683 347.756470,129.000000
	C304.539490,129.000000 261.724579,128.998474 218.909653,129.006378
	C217.414291,129.006653 215.682022,128.623169 214.461578,129.228210
	C205.749756,133.547211 200.756607,138.951355 202.033188,151.237915
	C202.826447,158.872574 211.218414,165.969803 219.496384,165.977463
	C268.822754,166.023041 318.149292,166.052216 367.475494,165.949600
	C375.889252,165.932098 385.468414,158.840408 385.072235,148.259720
	C384.725952,139.011536 385.000000,129.740128 385.000000,120.614922
	C412.557343,148.172134 439.987244,175.601929 466.103180,201.717758
	C439.169830,228.652878 411.956024,255.868484 384.998688,282.827606
	C385.256683,283.449951 385.041656,283.172363 385.040771,282.894043
	C385.014099,274.729004 384.444092,266.515991 385.131592,258.409943
	C386.177551,246.077057 376.881561,237.912567 364.641174,237.937851
	C300.317139,238.070648 235.992691,238.000000 171.668396,238.000000
	C169.887833,238.000000 168.107285,238.000000 166.000000,238.000000
	C166.000000,220.083755 165.784180,202.620132 166.090118,185.165665
	C166.245392,176.307068 162.366760,170.171692 154.845901,166.462753
	C147.711319,162.944351 138.714127,165.619675 133.029465,171.351974
	C89.100868,215.648529 45.028099,259.802124 1.000001,304.000000
z"
      />
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M1.000001,304.466125
	C45.028099,259.802124 89.100868,215.648529 133.029465,171.351974
	C138.714127,165.619675 147.711319,162.944351 154.845901,166.462753
	C162.366760,170.171692 166.245392,176.307068 166.090118,185.165665
	C165.784180,202.620132 166.000000,220.083755 166.000000,238.000000
	C168.107285,238.000000 169.887833,238.000000 171.668396,238.000000
	C235.992691,238.000000 300.317139,238.070648 364.641174,237.937851
	C376.881561,237.912567 386.177551,246.077057 385.131592,258.409943
	C384.444092,266.515991 385.014099,274.729004 385.040771,282.894043
	C385.041656,283.172363 385.256683,283.449951 384.998688,282.827606
	C411.956024,255.868484 439.169830,228.652878 466.103180,201.717758
	C439.987244,175.601929 412.557343,148.172134 385.000000,120.614922
	C385.000000,129.740128 384.725952,139.011536 385.072235,148.259720
	C385.468414,158.840408 375.889252,165.932098 367.475494,165.949600
	C318.149292,166.052216 268.822754,166.023041 219.496384,165.977463
	C211.218414,165.969803 202.826447,158.872574 202.033188,151.237915
	C200.756607,138.951355 205.749756,133.547211 214.461578,129.228210
	C215.682022,128.623169 217.414291,129.006653 218.909653,129.006378
	C261.724579,128.998474 304.539490,129.000000 347.756470,129.000000
	C347.842102,127.451683 347.988281,126.024178 347.989716,124.596519
	C348.005920,108.432137 348.277893,92.261337 347.905975,76.105507
	C347.641418,64.614304 354.518890,56.272812 366.283325,55.218140
	C371.309875,54.767517 376.398621,56.911221 380.252808,60.764545
	C422.912781,103.415031 465.585083,146.053253 508.157562,188.790909
	C510.015137,190.655685 510.940643,193.448868 512.650146,195.904785
	C513.000000,200.024551 513.000000,204.049088 513.000000,208.536835
	C509.832031,212.668121 506.877655,216.549301 503.463562,219.971939
	C462.626373,260.911102 421.707184,301.768433 380.848206,342.685913
	C374.703583,348.839325 367.436768,350.901703 359.501862,347.662109
	C353.138977,345.064331 347.739502,338.933807 347.912140,329.221588
	C348.223053,311.730225 348.000000,294.229370 348.000000,276.000000
	C346.205750,276.000000 344.462433,276.000000 342.719147,276.000000
	C278.228607,276.000000 213.737930,275.932098 149.247650,276.058777
	C136.752945,276.083313 127.937332,267.468109 128.860474,255.978958
	C129.563278,247.232178 129.000000,238.383667 129.000000,230.268814
	C101.809715,257.457855 74.363640,284.902679 47.376148,311.888947
	C73.996674,338.525513 101.384079,365.929443 129.000000,393.562012
	C129.000000,384.295197 129.276047,375.033813 128.927582,365.796021
	C128.524887,355.120026 138.103210,348.075378 146.468689,348.056091
	C195.794525,347.942200 245.120789,347.979126 294.446838,348.020416
	C302.729706,348.027374 311.165100,355.076294 311.960327,362.705780
	C313.236420,374.948669 308.414429,380.326508 299.593872,384.760895
	C298.378754,385.371765 296.642456,384.992859 295.147430,384.993164
	C252.327164,385.001648 209.506897,385.000000 166.238892,385.000000
	C166.156418,386.500275 166.011536,387.922852 166.010178,389.345520
	C165.994308,406.009735 166.076843,422.674500 165.967209,439.337982
	C165.913269,447.537537 162.231812,453.702118 154.590363,457.051117
	C147.246857,460.269562 139.567413,458.833771 133.740143,453.050659
	C90.923378,410.558594 48.326084,367.845306 5.721942,325.139557
	C4.055612,323.469269 3.019944,321.169769 1.345215,319.081726
	C1.000000,314.310760 1.000000,309.621490 1.000001,304.466125
z"
      />
    </svg>
  );
};
export default FileTransferSvg;
